import { render, staticRenderFns } from "./DashboardLayout.vue?vue&type=template&id=9ca72a40"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/layouts/DashboardLayout.vue
// module id = null
// module chunks = 